import React from 'react';

export const ChronogramLoading: React.FC = ( ) => {
  const elements = [
    { length: 200, start: 6, end: 10 },
    { length: 150, start: 2, end: 4 },
    { length: 160, start: 3, end: 5 },
    { length: 180, start: 9, end: 10 },
    { length: 160, start: 4, end: 7 },
    { length: 170, start: 3, end: 8 },
    { length: 150, start: 1, end: 2 },
    { length: 190, start: 6, end: 10 },
  ];

  return ( <div>
    <>
      <div className='animate-pulse'>
        <div className="mx-2 overflow-x-hidden">
          <div className="">
            <div className="w-full" >

              <div className="h-full w-72"/>

              <div className=''>
                <div className="grid w-full ml-10 h-full items-end grid-cols-9">
                  <div className="h-full"/>
                  { elements.map( ( element, index ) => {
                    return <div
                      key={index}
                      className='h-5 my-1 w-10 bg-blue-100 rounded-xl'
                    />;
                  } ) }
                </div>
              </div>
            </div>
            <div className='flex'>
              <div className='h-full w-72 '>
                { elements.map( ( { length }, index ) => {
                  return <div
                    key={index}
                    className='h-3 my-3 mx-3 bg-blue-100 rounded-xl'
                    style={{ width: length }}
                  />;
                } ) }
              </div>
              <div className='grid grid-cols-10 h-full w-full'>
                { elements.map( ( { start, end }, index ) => {
                  return <div
                    key={index}
                    className='h-5 my-1 bg-blue-100 rounded-xl'
                    style={{ gridColumnStart: start, gridColumnEnd: end }}
                  />;
                } ) }
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  </div>
  );

};
